async function load({ fetch, url }) {
  const serif = "https://api.mediumsans.com/fr/serif.json";
  const res = await fetch(serif);
  const data = await res.json();
  const stripeSuccess = url.searchParams.get("success") === "true";
  return {
    serif: data,
    stripeSuccess
  };
}
export {
  load
};
